let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("b8RiO")).then(() => parcelRequire('exldq'));